var map = {
	"./Cat-purring-sound.wav": 7915,
	"./Summer-insect-sounds-night.mp3": 708,
	"./Wind-chimes-sound.mp3": 1256,
	"./birds.fade.ogg": 4727,
	"./campfire.mp3": 9866,
	"./coffee.mp3": 4852,
	"./fire-large-flame.mp3": 7795,
	"./forest-windy-bird.mp3": 9292,
	"./light-rain.mp3": 9935,
	"./ocean-wave.mp3": 9791,
	"./rain-concrete.mp3": 9061,
	"./rain-light-in-nature.mp3": 8014,
	"./rain_1.ogg": 4220,
	"./river.mp3": 8269,
	"./thunder.fade.ogg": 420,
	"./wind-strong.mp3": 7133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5852;